export default __webpack_public_path__ + "static/media/nft-marketplace.7cd1b201.jpeg";